export const menuItems = [
  {
    id: 1,
    label: "Menu",
    isTitle: true,
  },
  {
    id: 2,
    label: "Inicio",
    icon: "bx-home-circle",
    link: "/",
    parentId: 2,
  },
  {
    id: 6,
    label: "Reconstructores",
    icon: "bx bx-face",
    link: "/reconstructores/index",
  },
  {
    id: 3,
    label: "Empleados",
    icon: "bx bxs-group",
    link: "/usuarios/index",
  },
  {
    id: 4,
    label: "Menu App Recnet",
    icon: "bx bx-mobile-alt",
    // El contenido que administra la app se agrupa aquí; los nombres coinciden
    // con las secciones de la app (Comercios, Producciones).
    subItems: [
      {
        id: 41,
        label: "Comercios",
        link: "/empresas/index",
        parentId: 4,
      },
      {
        id: 42,
        label: "Producciones",
        link: "/videos/index",
        parentId: 4,
      },
      {
        id: 43,
        label: "Espacios Recnet",
        link: "/actividades/index",
        parentId: 4,
      },
    ],
  },
  {
    id: 8,
    label: "Suscriptores",
    icon: "bx bx-credit-card",
    subItems: [
      {
        id: 81,
        label: "Recnet Plus",
        link: "/plus/index",
        parentId: 8,
      },
      {
        id: 82,
        label: "Sin membresía",
        link: "/suscriptores/sin-membresia",
        parentId: 8,
      },
    ],
  },
  {
    id: 10,
    label: "Bitácora",
    icon: "bx bx-history",
    link: "/bitacora/index",
    // Sólo visible para el rol admin; ver src/components/side-nav.vue.
    soloAdmin: true,
  },
];
